import { render, staticRenderFns } from "./project.vue?vue&type=template&id=04bb2468&scoped=true"
import script from "./project.vue?vue&type=script&lang=ts"
export * from "./project.vue?vue&type=script&lang=ts"
import style0 from "./project.vue?vue&type=style&index=0&id=04bb2468&prod&scoped=true&lang=css"
import style1 from "./project.vue?vue&type=style&index=1&id=04bb2468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb2468",
  null
  
)

export default component.exports